const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

const SCROLL_ANIMATION_ARMED_CLASSNAME = 'scroll-trigger--armed';
const scrollAnimationTargets = new WeakSet();

function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (!element.isIntersecting) return;
    const target = element.target;
    if (!target.classList.contains(SCROLL_ANIMATION_CANCEL_CLASSNAME)) {
      target.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      if (target.hasAttribute('data-cascade')) target.style.setProperty('--animation-order', Math.min(index, 3));
    }
    observer.unobserve(target);
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const elements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  const disabled = isDesignModeEvent || window.Shopify?.designMode || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window);
  let observer;
  elements.forEach((element) => {
    if (!disabled && scrollAnimationTargets.has(element)) return;
    scrollAnimationTargets.add(element);
    const rect = element.getBoundingClientRect();
    if (disabled || rect.top < window.innerHeight + 200 || element.parentElement.closest('.scroll-trigger')) {
      element.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME, SCROLL_ANIMATION_ARMED_CLASSNAME);
      element.classList.add(SCROLL_ANIMATION_CANCEL_CLASSNAME);
      return;
    }
    element.classList.add(SCROLL_ANIMATION_ARMED_CLASSNAME, SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
    element.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    if (!observer) observer = new IntersectionObserver(onIntersection, { rootMargin: '200px 0px' });
    observer.observe(element);
  });
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

function initializeScrollAnimations() {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
}
if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', initializeScrollAnimations, { once: true });
else initializeScrollAnimations();

if (window.Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
